'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _republishMessage = require('../../actions/PublishActions/republishMessage');

var _getChatHeadingConfig = require('../../chat-heading-config/selectors/getChatHeadingConfig');

var _navigateToStagedThread = require('../../navigation/actions/navigateToStagedThread');

var _navigateToThreadList = require('../../navigation/actions/navigateToThreadList');

var _getChatHeadingResponders = require('../../responders/selectors/getChatHeadingResponders');

var _getInitialMessageText = require('../../selectors/widgetDataSelectors/getInitialMessageText');

var _getIsMobile = require('../../selectors/getIsMobile');

var _getIsOpen = require('../../selectors/getIsOpen');

var _getShowInitialMessage = require('../../selectors/getShowInitialMessage');

var _getInitialMessageBubbleVisible = require('../../initial-message-bubble/selectors/getInitialMessageBubbleVisible');

var _closeInitialMessageBubble = require('../actions/closeInitialMessageBubble');

var _handleInitialMessageBubbleClick = require('../actions/handleInitialMessageBubbleClick');

var _InitialMessageBubble = require('conversations-visitor-experience-components/visitor-widget/InitialMessageBubble');

var _InitialMessageBubble2 = _interopRequireDefault(_InitialMessageBubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    chatHeadingConfig: (0, _getChatHeadingConfig.getChatHeadingConfig)(state),
    chatHeadingResponders: (0, _getChatHeadingResponders.getChatHeadingResponders)(state),
    initialMessage: (0, _getInitialMessageText.getInitialMessageText)(state),
    mobile: (0, _getIsMobile.getIsMobile)(state),
    initialMessageBubbleIsEnabled: (0, _getShowInitialMessage.getShowInitialMessage)(state),
    isVisible: (0, _getInitialMessageBubbleVisible.getInitialMessageBubbleVisible)(state),
    widgetIsOpen: (0, _getIsOpen.getIsOpen)(state)
  };
};

var mapDispatchToProps = {
  createNewThread: _navigateToStagedThread.navigateToStagedThread,
  onClick: _handleInitialMessageBubbleClick.handleInitialMessageBubbleClick,
  republishMessage: _republishMessage.republishMessage,
  showThreadList: _navigateToThreadList.navigateToThreadList,
  onClose: _closeInitialMessageBubble.closeInitialMessageBubble
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InitialMessageBubble2.default);
module.exports = exports['default'];